import React from 'react'
import tpvlogo from '../../../images/tpv_logo.svg'
import '../../../assets/sass/components/forgotPassword.scss'
type Props ={
  role?:string
}
export default function CommonLogin({role}:Props) {
  return (
    
      <div className='d-flex flex-column w-60 '>
        <div className='d-flex flex-row h-60px pt-16 mt-5 w-255px align-items-center justify-content-start' style={{marginLeft:'55px'}}>
          <img src={tpvlogo} className='h-50px w-82px' alt='' />
        </div>
        <div className='d-flex flex-column  h-271px w-600px pb-5 mb-5 align-items-center justify-content-center bottomCard' style={{paddingTop:'290px'}}>
          <div className='w-75  h6 d-flex flex-row'>
            <div className='horzLine'></div>
            <h5 className='text-white TPVText px-5'>{role}</h5>
            <h5 className='text-white TPVText '>A D M I N</h5>
          </div>
          <div className='w-600px bottomDescription'>
            <h1 className='text-white TPVDescription'>
              Fast, Accurate and Reliable Verifications You Can Trust.
            </h1>
          </div>
        </div>
      </div>
   
  )
}
